import React from 'react';
import classNames from 'classnames';

import Icon, { IconNames } from './presenter';

import { iconDefaultProps, iconPropTypes } from './iconPropTypes';


const SortIcon = ({ className, size, ...rest }) => (
  <Icon
    className={classNames({
      'j-sort-icon': true,
      [className]: className,
    })}
    name={IconNames.SORT}
    size={size}
    {...rest}
  />
);

SortIcon.propTypes = {
  ...iconPropTypes,
};

SortIcon.defaultProps = {
  ...iconDefaultProps,
};


export default SortIcon;
